<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 避難所情報詳細（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>避難所情報詳細（追加・編集）の説明</span></mat-card-title>
    </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/shelter-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          IDを設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 名称
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          編集ボタンから<a [href]="nameDialogLink">編集用ダイアログ</a>を開き設定します。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> マップ情報
        </div>
        <div class="manual-explain">
          マップ情報を設定します。<br>
          マップ内の検索キーワード、または緯度軽度から指定可能です。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> MAPページに位置を表示する
        </div>
        <div class="manual-explain">
          チェックを入れることで、MAPページにGoogleMapを表示しピンを立てます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集内容が更新されます。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Home</a> » Shelter Information Details (Add/Edit) Description
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Shelter Information Details (Add/Edit) Description</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_shelter-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button closes the dialog.<br>
          Any edited content will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Set the ID.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Name
        </div>
        <div class="manual-explain">
          Set the name.<br>
          Click the edit button to open the <a [href]="nameDialogLink">Edit Dialog</a>.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Map Information
        </div>
        <div class="manual-explain">
          Set the map information.<br>
          You can specify by search keywords or latitude and longitude in the map.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Display Location on MAP Page
        </div>
        <div class="manual-explain">
          Check this box to display a Google Map with a pin on the MAP page.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button updates the edited content.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
